import { CONSENT_MANAGEMENT_READY_EVENT } from "Constants/eventTypes";

import EditModeService from "./EditModeService";
import StorageService from "./StorageService";

export class ConsentManagementService {
  consentCategories: Set<string> = new Set();

  constructor() {
    // The block editor loads this bundle in the <head> of its canvas iframe, where document.body does not exist yet.
    const dispatchReady = () => document.body?.dispatchEvent(new CustomEvent(CONSENT_MANAGEMENT_READY_EVENT));
    if (document.body) {
      dispatchReady();
    } else {
      document.addEventListener("DOMContentLoaded", dispatchReady, { once: true });
    }
  }

  setConsent(categoryKey: string, newConsent: boolean): void {
    this.consentCategories.add(categoryKey);
    return StorageService.addItem(this.getStorageKey(categoryKey), newConsent.toString());
  }

  getConsent(categoryKey: string): boolean {
    if (EditModeService.editModeActive) return true;
    this.consentCategories.add(categoryKey);
    return StorageService.getItem(this.getStorageKey(categoryKey)) === "true";
  }

  getAllCategories() {
    return Array.from(this.consentCategories);
  }

  observeCategory(categoryKey: string, callback: () => void) {
    StorageService.observeItem(this.getStorageKey(categoryKey), callback);
  }

  unobserveCategory(categoryKey: string, callback: () => void) {
    StorageService.unobserveItem(this.getStorageKey(categoryKey), callback);
  }

  private getStorageKey(categoryKey: string): string {
    return `wec-consent-${categoryKey}`;
  }
}

export default new ConsentManagementService();
